import React, {useState, useEffect} from 'react';
import { useRouter } from 'next/router';
import { useSelector, useDispatch} from 'react-redux';
import { loadCookie } from './cookieSlice';
import CookieNotice from './CookieNotice';
import CookieOptions from './CookieOptions';
import { getCookie, setCookie } from './cookieTools';

const CookieConsent = (props) => {
    
    const [step, editStep] = useState( null);
    const showOptions  = () => { editStep('options')}
    const showNotice  = () => { editStep('notice')}

    const cookieState = useSelector( state => state.cookie);
    const dispatch = useDispatch();
    const router = useRouter();
    
    useEffect( () => {
        if (cookieState.status == 'init') {
            checkCookie();
        }
    }, []
    );

    const checkCookie = () => {
        let ckconso = getCookie('ckconso');
        
        if (!ckconso) {
            editStep('notice');
        } else {
            let cookieOpt = JSON.parse(ckconso);
            dispatch(loadCookie(cookieOpt));
            if (cookieOpt.consented == 0) {
                editStep('notice');
            }
        }
    }

    const saveCookie = (opt) => {
        setCookie('ckconso', JSON.stringify(opt), 90);
        editStep(null);
        router.reload(window.location.pathname);
    }

    const showStep = step == 'notice' ?
            <CookieNotice 
                showOptions={showOptions}
                saveCookie={saveCookie}
            /> 
            :
            <CookieOptions 
                showNotice={showNotice}
                saveCookie={saveCookie}
            />;
    

    return (
        step && showStep
    );
}

export default CookieConsent;